import { useEffect, useState } from "react";
import { fetchDepartments, downloadDepartmentsExcel } from "../Api/ViewDepartment";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewDepartmentMaster = () => {
  const [departments, setDepartments] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadDepartments = async () => {
      try {
        const data = await fetchDepartments();
        setDepartments(data || []);
      } catch (error) {
        toast.error("🦄 Error fetching departments");
      }
    };

    loadDepartments();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadDepartmentsExcel();
      
      // Create a blob from the response
      const url = window.URL.createObjectURL(new Blob([response.data]));
      
      // Create a temporary anchor element
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'departments.xlsx');
      document.body.appendChild(link);
      
      // Trigger the download
      link.click();
      
      // Clean up
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      toast.success("Download started successfully!");
    } catch (error) {
      toast.error("🦄 Failed to download departments");
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    
      <div className="">
        <Container fluid className="list-container">
           <div className="header-background">
            <span className="header-list-title">View Department Master</span>
            <Button className="gradient-btn"
              // variant="primary" 
              onClick={handleDownload}
              disabled={isDownloading}
            >
              {isDownloading ? 'Downloading...' : 'Download Data'}
            </Button>
          </div>

          {departments.length > 0 ? (
            <div className="table-wrapper">
              <div className="table-scroll-container">
                <Table bordered hover className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Code</th>
                      <th>Description</th>
                      <th>Office Code</th>
                      <th>Created On</th>
                      <th>Created Time</th>
                      <th>Created By</th>
                      <th>Changed On</th>
                      <th>Changed Time</th>
                      <th>Changed By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {departments.map((dept, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{dept.code}</td>
                        <td>{dept.description}</td>
                        <td>{dept.officeCode}</td>
                        <td>{dept.createdOnDate ? moment(dept.createdOnDate).format("L") : "-"}</td>
                        <td>{dept.createdOnTime ? moment(dept.createdOnTime, "HH:mm:ss").format("LTS") : "-"}</td>
                        <td>{dept.createdBy}</td>
                        <td>{dept.changedOnDate ? moment(dept.changedOnDate).format("L") : "-"}</td>
                        <td>{dept.changedOnTime ? moment(dept.changedOnTime, "HH:mm:ss").format("LTS") : "-"}</td>
                        <td>{dept.changedBy || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <p className="no-data">No departments found.</p>
          )}
        </Container>
      </div>
    
  );
};

export default ViewDepartmentMaster;